<template>
  <div>
    <div class="forum-site-header">
      <span class="u-fontsize-lg u-mb-0">Sections on</span>
      <div class="forum-site-actions">
        <a
          class="link--search u-fontsize-lg u-weight-bold"
          :href="`${messageSearchUrl}?filters=site_name:${siteName}`"
        >
          {{ siteName }}
        </a>
        <note-buttons
          :watchlistMessage="{
            'url':siteUrl,
            'site': {
              'site_name': siteName,
              'site_id': siteId
            },
            'site_name': siteName,
            'site_watchlist': inWatchlist,
          }"
          :noteId="siteId"
          :noteName="siteName"
          :noteItem="'site'"
          :noteSiteId="siteId"
          :noteSiteName="siteName"
          :hasNotes="Boolean(parseInt(hasSiteNotes))"
          :indexType="'forum'"
          :siteLink="getSiteLink(siteName)"
        />
        <button
          class="loi-form-open-btn"
          :title="loiToolTip"
          @click.prevent="loiFormOpen = true"
        />
      </div>
    </div>

    <div
      v-if="loiFormOpen"
      class="topic-link-popup-form"
    >
      <location-of-interest-form
        :existingUrls="existingUrls"
        :formAction="loiFormAction"
        :fullTagList="existingTags"
        :initialData="sectionData"
        @formCancel="loiFormOpen = false"
        @formSubmit="refreshPage"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import LocationOfInterestForm from '../forms/LocationOfInterestForm'
import NoteButtons from '../notes/NoteButtons'

export default {
  name: 'ForumContextSiteHeader',
  components: {
    LocationOfInterestForm,
    NoteButtons,
  },
  props: {
    inWatchlist: {
      type: Boolean,
      required: true
    },
    messageSearchUrl: {
      type: String,
      default: ''
    },
    siteName: {
      type: String,
      default: ''
    },
    siteId: {
      type: String,
      default: ''
    },
    hasSiteNotes: {
      type: String,
      default: ''
    },
    siteUrl: {
      type: String,
      default: ''
    },
    message: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      note: '',
      noteType: '',
      noteCategory: '',
      existingTags: [],
      existingUrls: [],
      forumsData: [],
      loiFormAction: 'create',
      loiFormOpen: false,
      loiToolTip: '',
      sectionData: {},
      siteWatchlist: ''
    }
  },
  mounted() {
    // get site info for creating or editing a location of interest
    axios.get(`/en/topic/forum_posts/${this.siteId}`).then(response => {
      if (response.status === 200) {
        this.existingUrls = response.data.existing_urls
        this.existingTags = response.data.existing_tags
        this.sectionData = response.data.topic_link
        if (this.sectionData == null) {
          this.loiFormAction = 'create'
          this.loiToolTip = 'Create a new location of interest for section.'
          this.sectionData = {
            'url': this.siteUrl,
            'title': this.siteName
          }
        } else {
          this.loiFormAction = 'update'
          this.loiToolTip = 'Update the location of interest for section.'
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  methods: {
    getSiteLink(siteName) {
      return new URL('/en/message-search/forum-sites/' + siteName + '/', document.baseURI).href
    },
    refreshPage() {
      window.location.reload()
    }
  },
}
</script>

<style scoped>

.forum-site-header {
  display: flex;
  flex-flow: column;
  .forum-site-actions {
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    align-items: center;
    .loi-form-open-btn {
      width: 32px;
      height: 32px;
      background-image: url('/static/images/icons/icon-globe.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
}

</style>
